//css
import "../../src/styles/App.css";
import Logo from "../styles/img/header.svg";

//react-redux
import React, { useEffect, useState } from "react";
import { isMobile, isTablet } from "react-device-detect";
import { MdCancel } from "react-icons/md";
import { store } from "../services/api/store";
import { scanToken } from "../services/api/slices/paladin";
import { datadogLogs } from "@datadog/browser-logs";

//hooks
import RoundLoader from "../hooks/RoundLoader";
//import useScript from "../hooks/useScript";

//components
import Layout from "../components/screens/Layout";
import InvitationFail from "./screens/Errors/InvitationFail";

const App = () => {
  const [loading, setLoading] = useState(false);
  const { dispatch } = store;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const token = urlSearchParams.get("token");
  const [responseScan, setResponseScan] = useState();
  const [tenantColor, setTenantColor] = useState("#6A2ABD");
  const [tenantImage, setTenantImage] = useState(Logo);
  const [tenantName, setTenantName] = useState("");

  const queryData = async () => {
    setLoading(true);
    var data = { token };

    try {
      const response = await dispatch(scanToken({ data }));
      setResponseScan(response?.payload);
      setTenantColor(
        response?.payload?.ScanToken?.TenantCustomColor
          ? response?.payload?.ScanToken?.TenantCustomColor
          : "#6A2ABD"
      );
      setTenantImage(
        response?.payload?.ScanToken?.TenantLogo &&
          `data:image/jpeg;base64,${response?.payload?.ScanToken?.TenantLogo}`
      );
      setTenantName(
        response?.payload?.ScanToken?.TenantName
          ? response?.payload?.ScanToken?.TenantName
          : ""
      );
      setLoading(false);

      datadogLogs.logger.log(`Token Validated for Invite: ${response?.payload?.ScanToken?.InvitationId}`, {
        category: "token-validation",
        status: "info",
        invitationId: response?.payload?.ScanToken?.InvitationId,
        tenantName: response?.payload?.ScanToken?.TenantName,
      });
    } catch (error) {
      setLoading(false);

      datadogLogs.logger.log("Error validating token (App)", {
        category: "error-handling",
        status: "error",
        token: token,
      });

      datadogLogs.logger.log("Error validating token (App) - additional data", {
        category: "error-handling",
        status: "info",
        token: token,
        errorMessage: error?.message,
      });

      datadogLogs.logger.log("Exception occurred during token validation", {
        status: "error",
        errorMessage: error?.message,
      });
    }
  };

  const initialize = () => {
    let callback = {
      onSuccess: function () {
        window.AcuantJavascriptWebSdk.start(
          () => {},
          false, //set to true if you want to run one worker at a time. Default to false.
          0 //set to 1 if hosting via cdn, defaults to 0
        );
      },
      onFail: function (code, description) {
        datadogLogs.logger.log("Error initializing worker", {
          category: "worker-initialization",
          status: "error",
          errorCode: code,
        });

        datadogLogs.logger.log("Exception during worker initialization", {
          status: "error",
          errorCode: code,
          errorDescription: description,
        });
      },
    };

    let base64Token = btoa(
      process.env.REACT_APP_USER_NAME + ":" + process.env.REACT_APP_PASSWORD
    );
    window.AcuantJavascriptWebSdk.initialize(
      base64Token, //Acuant credentials in base64 (basic auth format id:pass)
      process.env.REACT_APP_ACUANT_ACAS_ENDPOINT, //endpoint for Acuant's ACAS server
      callback, //callback shown below
      0 //set to 1 if hosting via cdn, defaults to 0
    );
  };

  useEffect(() => {
    initialize();
    //loadScript();
    if (isMobile || isTablet) {
      queryData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isMobile || isTablet ? (
        <>
          {loading && (
            <section className="flex justify-center items-center min-h-screen flex-col gap-3 container px-3 py-5 bg-[#F8F7F6] w-full">
              <RoundLoader
                loading={loading}
                responseScan={responseScan}
                tenantColor={tenantColor}
                tenantImage={tenantImage}
                tenantName={tenantName}
              />
            </section>
          )}
          <section>
            {!loading && (
              <>
                {
                  <section className="flex justify-start items-center flex-col gap-3 container px-3 py-1 bg-[#F8F7F6] w-full">
                    {responseScan?.ScanToken?.Success && (
                      <Layout
                        responseScan={responseScan}
                        tenantColor={tenantColor}
                        tenantImage={tenantImage}
                        tenantName={tenantName}
                      />
                    )}
                    {responseScan?.error && <InvitationFail />}
                  </section>
                }
              </>
            )}
          </section>
        </>
      ) : (
        <div className="flex justify-center items-center min-h-screen flex-col gap-3 container px-3 py-5 bg-[#F8F7F6] w-full">
          <MdCancel size={150} className="text-[#E43122]" />
          <h2 className="text-2xl text-[#E43122]">Error</h2>
          <p className="my-5 text-center text-sm">
            PALIDIN WebID is not available for desktop computers. <br></br>
            Please open the authentication invitation on a mobile device.
          </p>
        </div>
      )}
    </>
  );
};

export default App;
